import IconDown from 'assets/icons/dropDown.svg'
import IconUp from 'assets/icons/drop-black-up.svg'
import iconChecked from 'assets/icons/check-preenchido.svg'
import type React from 'react'
import { useEffect, useState } from 'react'
import './styles.scss'

import { Device } from 'components/Device'

interface DropdownCardProps {
  title: string
  description?: string
  children: React.ReactElement | React.ReactElement[]
}

function DropdownCard({ title, description, children }: DropdownCardProps) {
  const [isOpened, setIsOpened] = useState<boolean>(false)
  const [alertNumber, setAlertNumber] = useState<number>(0)

  const device = Device.useDevice()
  const devicePrefix = device.prefix()

  useEffect(() => {
    if (Array.isArray(children)) {
      let alertsCounter = 0
      children.forEach((card: React.ReactElement) => {
        if (card.props.isAlert === true) {
          alertsCounter += 1
        }
      })
      setAlertNumber(alertsCounter)
    }
  }, [])

  return (
    <div
      className={
        `container-dropdownCard ${devicePrefix ?? 'undefined'}` +
        (isOpened ? ' open' : '') +
        (alertNumber !== 0 ? ' alert' : '')
      }
      style={{ order: `${-alertNumber}` }}
    >
      <div
        className="dropdownCard__collapse cardAnimated"
        onClick={() => {
          setIsOpened(!isOpened)
        }}
      >
        {alertNumber !== 0 ? (
          <span className="dropdownCard__number">{alertNumber}</span>
        ) : (
          <img src={iconChecked} alt="ok" height="30px" />
        )}
        <div className="dropdownCard__content">
          <h2>
            <strong>{title}</strong>
          </h2>
          <p style={{ fontStyle: 'italic' }}>{description}</p>
        </div>
        <div className="dropdownCard__icon">
          <img src={isOpened ? IconUp : IconDown} alt="icon Dropdown" />
        </div>
      </div>
      {isOpened && <div className="dropdownCard__inner">{children}</div>}
    </div>
  )
}

export default DropdownCard
